export default __webpack_public_path__ + "static/media/462.666272a5.png";